// src/features/boe/components/programs/Program0900.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_0900_CONFIG = {
  fullName: "CAREER & TECHNICAL EDUCATION",
  docId: "0900",

  fieldDefs: [
    // Positions (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },

    // Salaries
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "transportTechnicalSchools",
      label: "Transport / Technical Schools",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Transport/Technical Schools" },
        { block: "Salaries", key: "Transport / Technical Schools" },
        { block: "Purchased Services", key: "Transport/Technical Schools" },
        { block: "Purchased Services", key: "Transport / Technical Schools" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips" },
        { block: "Supplies / Materials", key: "Field Trips" },
        { block: "Purchased Services", key: "Field Trips" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // Supplies / Materials
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology Software",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Technology Software" }],
      group: "materials",
      defaultVisible: false,
    },

    // Other
    {
      key: "duesFees",
      label: "Dues & Fees",
      valueType: "currency",
      sources: [{ block: "Other", key: "Dues and Fees" }],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approvedMain",
      title: "0900 CAREER & TECHNICAL EDUCATION – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "transportTechnicalSchools",
        "fieldTrips",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsTeachers: { minWidth: "150px" },

        // Salaries / Services
        salariesAdmin: { minWidth: "130px" },
        salariesTeachers: { minWidth: "150px" },
        transportTechnicalSchools: { minWidth: "190px" },
        fieldTrips: { minWidth: "110px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "170px" },
        technologySoftware: { minWidth: "160px" },
        duesFees: { minWidth: "100px" },
      },
    },
    {
      id: "actualMain",
      title: "0900 CAREER & TECHNICAL EDUCATION – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "transportTechnicalSchools",
        "fieldTrips",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsTeachers: { minWidth: "150px" },

        // Salaries / Services
        salariesAdmin: { minWidth: "130px" },
        salariesTeachers: { minWidth: "150px" },
        transportTechnicalSchools: { minWidth: "190px" },
        fieldTrips: { minWidth: "110px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "170px" },
        technologySoftware: { minWidth: "160px" },
        duesFees: { minWidth: "100px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program0900(props) {
  return (
    <ProgramBudget programId="0900" config={PROGRAM_0900_CONFIG} {...props} />
  );
}
